import type { HTMLChakraProps } from '@chakra-ui/react';
import { Box, Text } from '@chakra-ui/react';
import React from 'react';

import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';

const Footer = () => {
  const containerProps: HTMLChakraProps<'div'> = {
    as: 'footer',
    borderTopWidth: '1px',
    borderTopColor: 'solid',
  };

  return (
    <Box { ...containerProps }>
      <Box
        px={{ base: 4, lg: 6, '2xl': 6 }}
        py={{ base: 4, lg: 8 }}
        maxW={`${ CONTENT_MAX_WIDTH }px`}
        m="0 auto"
        textAlign="center"
      >
        <Text fontSize="xs" lineHeight={ 5 }>
          Copyright © Alchemy Chain 2025
        </Text>
      </Box>
    </Box>
  );
};

export default React.memo(Footer);
